import styled from 'styled-components';

const Styles = styled.div`
  .modal {
    background-color: #00000077;
    position: fixed;
    top: 0%;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card {
    text-align: center;
    padding: 10px;
    min-width: 300px;
  }
  .btnY {
    padding: 10px 30px;
    border-radius: 5px;
    border: 3px solid #f9d507;
    color: #000000;
    transition: 0.2s;
    font-weight: 600;
    font-size: 17px;
    background-color: #f9d507;
  }
  .btnY:hover {
    box-shadow: 3px 5px 15px #e2e2e2;
  }
  .centerCard {
    display: flex;
    justify-content: center;
  }
  .btnN {
    padding: 10px 30px;
    border-radius: 5px;
    border: 3px solid red;
    color: red;
    transition: 0.2s;
    font-weight: 600;
    font-size: 17px;
  }
  .btnN:hover {
    background-color: #f9d507;
    color: white;
  }
  .img {
    width: 100px;
  }
  .title {
    margin: 10px 0;
  }
`;
export default Styles;
